import { FC, useMemo } from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'

import { Badge } from '../../badge'
import DropdownButton from '../../dropdown-button/dropdown-button'
import { IListItemProps } from '../../list'

import { useSafetyCaseHazardMitigationTypesQuery } from '../../../services'
import { ISafetyCaseHazardMitigation } from '../../../interfaces'

import s from '../card.module.scss'

type SafetyCaseHazardMitigationCardProps = ISafetyCaseHazardMitigation & IListItemProps<ISafetyCaseHazardMitigation>

const SafetyCaseHazardMitigationCard: FC<SafetyCaseHazardMitigationCardProps> = props => {
  const { id, description, mitigationType, statusText, workOrders, componentRef, activeId, actionsButtonOptions } =
    props

  const { data: mitigationTypes } = useSafetyCaseHazardMitigationTypesQuery(undefined, undefined)

  const mitigationTypeName = useMemo(
    () => mitigationTypes?.find(type => type.id === mitigationType)?.name,
    [mitigationTypes, mitigationType],
  )

  const title = useMemo(() => `#${id}${mitigationTypeName ? ` - ${mitigationTypeName}` : ''}`, [id, mitigationTypeName])

  return (
    <div
      className={cn('card card-custom border border-2 p-4 d-flex flex-column', activeId === id && s['active-card'])}
      ref={componentRef}
    >
      <div className={cn(s['card-header'], 'card-header border-0 m-0 p-0')}>
        <div className="card-title font-weight-bold">{title}</div>

        {actionsButtonOptions && (
          <DropdownButton className={s['actions-button']} accessor={props} options={actionsButtonOptions} />
        )}
      </div>

      <div className="card-body p-0">
        {description && <div className="mt-2 text-truncate">{description}</div>}

        {workOrders && workOrders.length > 0 && (
          <div className="mt-2 d-flex flex-wrap align-items-center">
            <span className="mr-2">Work Order{workOrders.length > 1 ? 's' : ''}:</span>

            {workOrders.map((workOrder, index) => (
              <span key={workOrder.id}>
                <Link to={`/work-orders/${workOrder.id}`}>#{workOrder.id}</Link>
                {index < workOrders.length - 1 && ', '}
              </span>
            ))}
          </div>
        )}
      </div>

      {statusText && (
        <div className="border-0 card-footer d-flex justify-content-end mt-auto mx-0 p-0 pt-2">
          <Badge status={statusText} marginNone />
        </div>
      )}
    </div>
  )
}

export default SafetyCaseHazardMitigationCard
